module.exports = __webpack_public_path__ + "static/media/correctEntries.f9d2b3cc.png";